import { useEffect, useRef, useState } from "react";
import { getControlledList } from "../../utils/constants";

export function useParticipantDisplayVocabularies({
  callApiWithWorker,
  lang,
  enabled = true,
}) {
  const callApiWithWorkerRef = useRef(callApiWithWorker);
  const [vocabularies, setVocabularies] = useState({
    countries: [],
    provinces: [],
    organizationType: [],
    governmentFunctions: [],
  });

  callApiWithWorkerRef.current = callApiWithWorker;

  useEffect(() => {
    if (!enabled || !callApiWithWorkerRef.current || !lang) return;

    let cancelled = false;

    async function fetchParticipantVocabularies() {
      try {
        const [countries, provinces, organizationType, governmentFunctions] =
          await Promise.all([
            getControlledList(callApiWithWorkerRef.current, "countries", {
              lang,
              connector: "springConnector",
            }),
            getControlledList(callApiWithWorkerRef.current, "provincias", {
              lang,
              connector: "springConnector",
            }),
            getControlledList(callApiWithWorkerRef.current, "organizationtypes-eu", {
              lang,
              connector: "springConnector",
            }),
            getControlledList(callApiWithWorkerRef.current, "government-functions", {
              lang,
              connector: "springConnector",
            }),
          ]);

        if (cancelled) return;

        setVocabularies({
          countries,
          provinces,
          organizationType,
          governmentFunctions,
        });
      } catch (error) {
        if (!cancelled) {
          console.error("Error fetching participant vocabularies:", error);
        }
      }
    }

    fetchParticipantVocabularies();

    return () => {
      cancelled = true;
    };
  }, [enabled, lang]);

  return vocabularies;
}
